import type { SearchItemType } from '@mimir/common/dto/itemTypes';
import type { SafeHtmlBuilder } from '@mimir/common/util/safeHtmlBuilder';

export enum NotificationStackItemType {
  Collapsible = 'collapsible',
  Progress = 'progress',
}
export interface INotificationStackItem {
  type: NotificationStackItemType;
  key: string;
  isClosed: boolean;
  isComplete: boolean;
}

export interface NotificationStackActionBtn {
  handler: () => void;
  tooltip: string;
  icon?: string;
}

export interface ICollapsibleNotification extends INotificationStackItem {
  type: NotificationStackItemType.Collapsible;
  title: string | SafeHtmlBuilder;
  description: string | SafeHtmlBuilder;
  showDragIcon: boolean;
  itemType?: SearchItemType;
  loading?: boolean;
  pathToDrag?: string;
  routeBtn?: Omit<NotificationStackActionBtn, 'icon'>;
}

export interface IProgressNotification extends INotificationStackItem {
  type: NotificationStackItemType.Progress;
  message: string | SafeHtmlBuilder;
  cancelBtn: Omit<NotificationStackActionBtn, 'icon'>;
  progress: number;
  routeBtn?: Omit<NotificationStackActionBtn, 'icon'>;
  actionBtn?: NotificationStackActionBtn;
  alert?: string;
}

export type NotificationStackItemMap = Record<string, INotificationStackItem>;

